import { Elements } from "@stripe/react-stripe-js";
import {
    Avatar,
    Box,
    Card,
    CardContent,
    CardHeader,
    CardMedia,
    Divider,
    Grid,
    List,
    ListItem,
    ListItemAvatar,
    ListItemSecondaryAction,
    ListItemText,
    Typography,
} from "@material-ui/core";
import { loadStripe } from "@stripe/stripe-js";
import { CheckCircle, Person } from "@material-ui/icons";
import PlayCircleFilledIcon from "@material-ui/icons/PlayCircleFilled";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchPaymentConfigRequest } from "../../store/shopping/shopping.actions";
import {
    getCategoryList,
    getPaymentConfig,
} from "../../store/shopping/shopping.selector";
import { fetchOtherUserProfileRequest } from "../../store/user/user.actions";
import {
    getImage,
    getOtherUserProfile,
    getUserProfile,
} from "../../store/user/user.selector";
import { getLiveStreams } from "../../store/social/social.selector";
import _ from "underscore";
import StripePaymentForm from "../payment/stripePaymentForm";
import Swal from "sweetalert2";
var stripePromise = null;
const ELEMENTS_OPTIONS = {
    fonts: [
        {
            cssSrc: "https://fonts.googleapis.com/css?family=Roboto",
        },
    ],
};

export default function VIPSubscriptionPayment(props) {
    const dispatch = useDispatch();
    const location = useLocation();
    const history = useNavigate();
    const [isAdd, setAdd] = useState(false);
    const [period, setPeriod] = useState("Yearly");
    const [canPayUsingCard, setPayUsingCard] = useState(false);
    const [existingCard, setExistingCard] = useState("");
    const [vipCircle, setVIPCircle] = useState({});

    useEffect(() => {
        if (location && location.state && location.state.VIPCircle) {
            setVIPCircle(location.state.VIPCircle);
        } else {
            history("/");
        }
    }, [location]);

    useEffect(() => {
        dispatch(fetchPaymentConfigRequest());
    }, []);

    const {
        userProfile,
        categories,
        liveStreams,
        otherUserProfile,
        paymentConfig,
    } = useSelector((state) => {
        return {
            userProfile: getUserProfile(state),
            otherUserProfile: getOtherUserProfile(state),
            paymentConfig: getPaymentConfig(state),
            liveStreams: getLiveStreams(state),
            categories: getCategoryList(state),
        };
    });

    useEffect(() => {
        if (paymentConfig && paymentConfig.publicKey) {
            stripePromise = loadStripe(paymentConfig.publicKey);
        }
    }, [paymentConfig]);

    const handleSave = () => {
        Swal.fire({
            title: "Subscription Successful",
            text: `You have successfully subscribed to ${vipCircle.title}. Please wait for sometime to confirm the subscription.`,
            icon: "success",
            showCancelButton: true,
            confirmButtonColor: "green",
            cancelButtonText: "Cancel",
            confirmButtonText: "Proceed",
            customClass: {
                cancelButton: "order-1 right-gap",
                confirmButton: "order-2",
                denyButton: "order-3",
            },
        }).then((x) => {
            if (x.isConfirmed) {
                history("/page/subscription/vip-circle");
            }
        });
    };
    return (
        <div className="p-2 sm:p-4 lg:px-8 h-full overflow-hidden flex flex-col">
            <div className="mb-[25px]">
                <h2 className="text-xl font-bold text-ebony-color">
                    Subscribe VIP Circle
                </h2>
                <p className="text-sm font-medium text-black-50">
                    You will only be charged once your request has been approved
                </p>
            </div>
            <div className="flex-1 overflow-y-auto p-4 bg-white rounded-lg border border-black-10">
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={12} lg={12} className="mt-2">
                        <Grid container spacing={2}>
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={4}
                                lg={4}
                                className="mt-2"
                            >
                                <div className="rounded-lg border border-black-10">
                                    <div className="relative">
                                        <img
                                            src={getImage(vipCircle.avatar)}
                                            alt=""
                                            className="rounded-tl-lg rounded-tr-lg w-full"
                                        />
                                        <div className="absolute left-0 top-0 right-0 bottom-0 flex flex-col justify-between p-2.5">
                                            <div className="flex items-center">
                                                <img
                                                    src={
                                                        otherUserProfile.avatar
                                                            ? getImage(
                                                                  otherUserProfile
                                                                      .avatar
                                                                      .attachments
                                                              )
                                                            : getImage(
                                                                  otherUserProfile.attachments
                                                              )
                                                    }
                                                    alt=""
                                                    className="w-8 h-8 rounded-full border border-white mr-[7px]"
                                                />
                                                <div className="">
                                                    <h5 className="text-sm font-medium text-white">
                                                        {
                                                            otherUserProfile.fullName
                                                        }
                                                    </h5>
                                                    <p className="text-extraSmall text-white/70">
                                                        @
                                                        {
                                                            otherUserProfile.userName
                                                        }
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="flex items-center">
                                                <div className="flex items-center text-sm text-white mr-4">
                                                    <span className="inline-block mr-[5px]">
                                                        <svg
                                                            width="18"
                                                            height="18"
                                                            viewBox="0 0 18 18"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <path
                                                                d="M3.26753 13.8364C4.96056 12.8795 6.9165 12.3333 9 12.3333C11.0835 12.3333 13.0394 12.8795 14.7325 13.8364M11.5 7.33333C11.5 8.71405 10.3807 9.83333 9 9.83333C7.61929 9.83333 6.5 8.71405 6.5 7.33333C6.5 5.95262 7.61929 4.83333 9 4.83333C10.3807 4.83333 11.5 5.95262 11.5 7.33333ZM16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z"
                                                                stroke="white"
                                                                strokeWidth="1.5"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            />
                                                        </svg>
                                                    </span>
                                                    <span>
                                                        {vipCircle.guests &&
                                                            vipCircle.guests.filter(
                                                                (x) =>
                                                                    x.status ===
                                                                    "Subscribed"
                                                            ).length}
                                                    </span>
                                                </div>
                                                <div className="flex items-center text-sm text-white">
                                                    <span className="inline-block mr-[5px]">
                                                        <svg
                                                            width="18"
                                                            height="18"
                                                            viewBox="0 0 18 18"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <path
                                                                d="M11.2933 8.30662L8.62892 6.53039C8.07512 6.16119 7.33333 6.55818 7.33333 7.22376V10.7762C7.33333 11.4418 8.07512 11.8388 8.62892 11.4696L11.2933 9.69338C11.788 9.36352 11.788 8.63648 11.2933 8.30662Z"
                                                                stroke="white"
                                                                strokeWidth="1.5"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            />
                                                            <path
                                                                d="M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z"
                                                                stroke="white"
                                                                strokeWidth="1.5"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            />
                                                        </svg>
                                                    </span>
                                                    <span>
                                                        {liveStreams &&
                                                            liveStreams.filter(
                                                                (x) =>
                                                                    x.parent ===
                                                                    vipCircle._id
                                                            ).length}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="">
                                        <div className="px-3 py-2 border-b border-black-10">
                                            <h3 className="text-base font-bold text-ebony-color">
                                                {vipCircle.title}
                                            </h3>
                                            <p className="text-sm font-medium text-black-60">
                                                {vipCircle.description}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={4}
                                lg={4}
                                className="mt-2"
                            >
                                <h3 className="text-base font-bold text-ebony-color mb-2">
                                    Subscription Type
                                </h3>
                                <Box
                                    textAlign="center"
                                    display="flex"
                                    width="100%"
                                    justifyContent="space-between"
                                    alignItems="center"
                                >
                                    <Card
                                        variant="outlined"
                                        className="center-div width-100-per m-1 relative"
                                        style={{
                                            borderColor:
                                                period === "Monthly"
                                                    ? "#E38301"
                                                    : "#CECECE",
                                        }}
                                        onClick={() => setPeriod("Monthly")}
                                    >
                                        <List disablePadding>
                                            <ListItem disableGutters>
                                                <ListItemText
                                                    primary={
                                                        <p className="text-medium text-center">
                                                            Monthly
                                                            <br />
                                                            <span className="text-bold text-large">
                                                                {vipCircle.currencySubscription +
                                                                    " " +
                                                                    vipCircle.monthlySubscription}
                                                            </span>
                                                        </p>
                                                    }
                                                />
                                            </ListItem>
                                        </List>
                                        {period === "Monthly" && (
                                            <CheckCircle
                                                color="secondary"
                                                className="absolute right-8"
                                            />
                                        )}
                                    </Card>
                                    <Card
                                        variant="outlined"
                                        className="center-div width-100-per m-1 relative"
                                        style={{
                                            borderColor:
                                                period === "Yearly"
                                                    ? "#E38301"
                                                    : "#CECECE",
                                        }}
                                        onClick={() => setPeriod("Yearly")}
                                    >
                                        <List disablePadding>
                                            <ListItem disableGutters>
                                                <ListItemText
                                                    primary={
                                                        <p className="text-medium text-center">
                                                            Yearly
                                                            <br />
                                                            <span className="text-bold text-large">
                                                                {vipCircle.currencySubscription +
                                                                    " " +
                                                                    vipCircle.annuallySubscription}
                                                            </span>
                                                        </p>
                                                    }
                                                />
                                            </ListItem>
                                        </List>
                                        {period === "Yearly" && (
                                            <CheckCircle
                                                color="secondary"
                                                className="absolute right-8"
                                            />
                                        )}
                                    </Card>
                                </Box>
                                <h3 className="text-base font-bold text-ebony-color my-2">
                                    Order Summary
                                </h3>
                                <List disablePadding>
                                    <ListItem disableGutters>
                                        <ListItemText
                                            primary={<>{period} subscription</>}
                                        />
                                        <ListItemSecondaryAction className="text-danger">
                                            {vipCircle.currencySubscription}{" "}
                                            {period === "Yearly"
                                                ? vipCircle.annuallySubscription
                                                : vipCircle.monthlySubscription}
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                    <Divider />
                                    <ListItem disableGutters>
                                        <ListItemText primary={<>Tax Fee</>} />
                                        <ListItemSecondaryAction>
                                            {vipCircle.currencySubscription}{" "}
                                            0.00
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                    <Divider />
                                    <ListItem disableGutters>
                                        <ListItemText primary={<b>Total</b>} />
                                        <ListItemSecondaryAction className="text-danger text-bold text-large">
                                            {vipCircle.currencySubscription}{" "}
                                            {period === "Yearly"
                                                ? vipCircle.annuallySubscription
                                                : vipCircle.monthlySubscription}
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                </List>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={4}
                                lg={4}
                                className="mt-2"
                            >
                                {stripePromise && vipCircle._id ? (
                                    <>
                                        <Elements
                                            stripe={stripePromise}
                                            options={ELEMENTS_OPTIONS}
                                        >
                                            <StripePaymentForm
                                                type="vip-circle"
                                                vipCircle={vipCircle}
                                                userId={vipCircle._id}
                                                isPaying={canPayUsingCard}
                                                billingPeriod={period}
                                                paymentConfig={paymentConfig}
                                                existingCard={existingCard}
                                                userProfile={userProfile}
                                                OnSuccess={handleSave}
                                                onCancel={() => {
                                                    let pvHall = _.find(
                                                        categories,
                                                        (x) =>
                                                            x.name ===
                                                            "VIP Circle"
                                                    );
                                                    if (
                                                        pvHall &&
                                                        otherUserProfile.userName
                                                    ) {
                                                        history(
                                                            "/user/" +
                                                                otherUserProfile.userName,
                                                            {
                                                                category:
                                                                    pvHall._id,
                                                            }
                                                        );
                                                    } else {
                                                        history.goBack();
                                                    }
                                                }}
                                                OnError={(err) =>
                                                    Swal.fire({
                                                        title: "Error Occured",
                                                        text: err.message,
                                                        icon: "error",
                                                        showCancelButton: false,
                                                        cancelButtonText:
                                                            "Cancel",
                                                        confirmButtonText:
                                                            "Close",
                                                        customClass: {
                                                            cancelButton:
                                                                "order-1 right-gap",
                                                            confirmButton:
                                                                "order-2",
                                                            denyButton:
                                                                "order-3",
                                                        },
                                                    })
                                                }
                                            />
                                        </Elements>
                                    </>
                                ) : (
                                    <span />
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        </div>
    );
}
